import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
export const fundRouter: RouteRecordRaw[] = [
    {
        path: "fund",
        name: "Fund",
        meta: {
            title: "资金管理"
        },
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/fund/payment",
        children: [
            {
                path: "payment",
                name: "Payment",
                component: () => import("@/views/pages/fundManagement/paymentManagement/index.vue"),
                meta: {
                    title: "付款管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "paymentDetail",
                name: "PaymentDetail",
                component: () => import("@/views/pages/fundManagement/paymentManagement/detail.vue"),
                meta: {
                    title: "付款详情",
                    isNotShowHeader: true,
                    activeMenu: "Payment",
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "paymentAdd",
                name: "PaymentAdd",
                component: () => import("@/views/pages/fundManagement/paymentManagement/form.vue"),
                meta: {
                    title: "新增付款",
                    activeMenu: "Payment",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "paymentEdit",
                name: "PaymentEdit",
                component: () => import("@/views/pages/fundManagement/paymentManagement/form.vue"),
                meta: {
                    title: "修改付款",
                    activeMenu: "Payment",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "collection",
                name: "Collection",
                component: () => import("@/views/pages/fundManagement/collectionManagement/index.vue"),
                meta: {
                    title: "收款管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "collectionDetail",
                name: "CollectionDetail",
                component: () => import("@/views/pages/fundManagement/collectionManagement/detail.vue"),
                meta: {
                    title: "收款详情",
                    activeMenu: "Collection",
                    isNotShowHeader: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "collectionAdd",
                name: "CollectionAdd",
                component: () => import("@/views/pages/fundManagement/collectionManagement/form.vue"),
                meta: {
                    title: "新增收款",
                    activeMenu: "Collection",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "collectionEdit",
                name: "CollectionEdit",
                component: () => import("@/views/pages/fundManagement/collectionManagement/form.vue"),
                meta: {
                    title: "修改收款",
                    activeMenu: "Collection",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refund",
                name: "Refund",
                component: () => import("@/views/pages/fundManagement/refundManagement/index.vue"),
                meta: {
                    title: "退款管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refundDetail",
                name: "RefundDetail",
                component: () => import("@/views/pages/fundManagement/refundManagement/detail.vue"),
                meta: {
                    title: "退款详情",
                    isNotShowHeader: true,
                    activeMenu: "Refund",
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refundAdd",
                name: "RefundAdd",
                component: () => import("@/views/pages/fundManagement/refundManagement/form.vue"),
                meta: {
                    title: "新增退款",
                    activeMenu: "Refund",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "refundEdit",
                name: "RefundEdit",
                component: () => import("@/views/pages/fundManagement/refundManagement/form.vue"),
                meta: {
                    title: "修改退款",
                    activeMenu: "Refund",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            // {
            //     path: "quotaChange",
            //     name: "QuotaChange",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/index.vue"),
            //     meta: {
            //         title: "额度变更",
            //         pageType: PAGE_TYPE.LIST.code,
            //         authOptions: [
            //             {
            //                 label: "查看",
            //                 value: "ROLE_PROJECT_R"
            //             },
            //             {
            //                 label: "查看所有",
            //                 value: "ROLE_PROJECT_ALL_R"
            //             },
            //             {
            //                 label: "处理",
            //                 value: "ROLE_PROJECT_DEAL"
            //             }
            //         ]
            //     }
            // },
            // {
            //     path: "quotaChangeAdd",
            //     name: "QuotaChangeAdd",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/form.vue"),
            //     meta: {
            //         title: "新增额度变更",
            //         activeMenu: "QuotaChange",
            //         isNotShowHeader: true,
            //         pageType: PAGE_TYPE.CACHE_FORM.code,
            //         hidden: true,
            //         authOptions: [
            //             {
            //                 label: "处理",
            //                 value: "ROLE_PROJECT_DEAL"
            //             }
            //         ]
            //     }
            // },
            // {
            //     path: "quotaChangeEdit",
            //     name: "QuotaChangeEdit",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/form.vue"),
            //     meta: {
            //         title: "修改额度变更",
            //         activeMenu: "QuotaChange",
            //         isNotShowHeader: true,
            //         pageType: PAGE_TYPE.CACHE_FORM.code,
            //         hidden: true,
            //         authOptions: [
            //             {
            //                 label: "处理",
            //                 value: "ROLE_PROJECT_DEAL"
            //             }
            //         ]
            //     }
            // },
            // {
            //     path: "quotaChangeDetail",
            //     name: "QuotaChangeDetail",
            //     component: () => import("@/views/pages/fundManagement/quotaChange/detail.vue"),
            //     meta: {
            //         title: "额度详情",
            //         activeMenu: "QuotaChange",
            //         isNotShowHeader: true,
            //         hidden: true,
            //         authOptions: [
            //             {
            //                 label: "查看",
            //                 value: "ROLE_PROJECT_R"
            //             },
            //             {
            //                 label: "查看所有",
            //                 value: "ROLE_PROJECT_ALL_R"
            //             },
            //             {
            //                 label: "处理",
            //                 value: "ROLE_PROJECT_DEAL"
            //             }
            //         ]
            //     }
            // },
            {
                path: "revenue",
                name: "Revenue",
                component: () => import("@/views/pages/fundManagement/revenue/index.vue"),
                meta: {
                    title: "收益测算",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "revenueDetail/:id",
                name: "RevenueDetail",
                component: () => import("@/views/pages/fundManagement/revenue/detail.vue"),
                meta: {
                    title: "收益测算详情",
                    activeMenu: "Revenue",
                    isNotShowHeader: true,
                    keepAlive: true,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
